module.exports = __webpack_public_path__ + "img/button.3c42bef8.png";